<div class="company-shell">
  <header class="company-header">
    <div>
      <h1>Target Company Intelligence</h1>
    </div>
    <div class="company-header__actions">
      <button type="button" class="button button--secondary" (click)="goBack()">
        Back to Target Areas
      </button>
      <button type="button" class="button button--ghost" (click)="refresh()">
        Refresh
      </button>
      <button
        type="button"
        class="button button--accent"
        (click)="generateContacts()"
        [disabled]="contactLoading()"
      >
        <span *ngIf="activeContactAction() !== 'all'">All Generate Company Contacts</span>
        <span *ngIf="activeContactAction() === 'all'" class="spinner">
          <span class="spinner__dot"></span>
          <span>Preparing...</span>
        </span>
      </button>
      <button
        type="button"
        class="button button--primary"
        (click)="viewContacts()"
        [disabled]="contactLoading()"
      >
        View All Company Contacts
      </button>
    </div>
  </header>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/audiences', serviceId()]" *ngIf="serviceId() as sid; else companyAudienceFallback">
      Target Audience Profiles
    </a>
    <ng-template #companyAudienceFallback>
      <span>Target Audience Profiles</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/target-areas', serviceId()]" *ngIf="serviceId() as sid2; else companyTargetFallback">
      Target Areas
    </a>
    <ng-template #companyTargetFallback>
      <span>Target Areas</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <span>Target Company Intelligence</span>
  </nav>

  <section class="company-status">
    <span class="status status--info" *ngIf="loading()">
      <span class="spinner__dot"></span>
      <span>Fetching company profiles...</span>
    </span>
    <span class="status status--success" *ngIf="!loading() && statusMessage()">
      {{ statusMessage() }}
    </span>
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
    <span class="status status--info" *ngIf="contactRecordsLoading()">
      <span class="spinner__dot"></span>
      <span>Loading company contacts...</span>
    </span>
    <span class="status status--error" *ngIf="contactError()">
      {{ contactError() }}
    </span>
  </section>

  <section
    class="company-table-wrapper"
    *ngIf="companyRows().length && !loading(); else emptyState"
  >
    <table class="company-table">
      <thead>
        <tr>
          <th>Company</th>
          <th>Audience Context</th>
          <th>Industry</th>
          <th>Location</th>
          <th>Size</th>
          <th>Website</th>
          <th class="company-table__actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of companyRows(); trackBy: trackByRow">
          <td>
            <span class="company-table__name">
              {{ row.name || 'N/A' }}
            </span>
          </td>
          <td>
            <div class="company-table__audience">
              <span class="company-table__title">
                {{ row.targetAudienceName || 'Target Audience' }}
              </span>
              <span class="company-table__subtitle" *ngIf="row.audienceType">
                {{ row.audienceType }}
              </span>
              <span class="company-table__subtitle" *ngIf="row.marketType">
                Market: {{ row.marketType }}
              </span>
            </div>
          </td>
          <td>{{ row.industry || 'N/A' }}</td>
          <td>{{ row.location || 'N/A' }}</td>
          <td>{{ row.size || 'N/A' }}</td>
          <td>
            <a
              *ngIf="row.website; else noWebsite"
              [href]="row.website"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ row.website }}
            </a>
          </td>
          <td class="company-table__actions">
            <button
              type="button"
              class="button button--accent button--small"
              (click)="generateContactsForCompany(row)"
              [disabled]="
                isContactCompleted(row) ||
                activeContactAction() === 'all' ||
                activeContactAction() === row.rowKey
              "
            >
              <ng-container *ngIf="activeContactAction() === row.rowKey; else generateContactsIdle">
                <ng-container *ngTemplateOutlet="contactPending"></ng-container>
              </ng-container>
            </button>
            <ng-template #generateContactsIdle>
              Generate Company Contacts
            </ng-template>
            <button
              type="button"
              class="button button--primary button--small"
              (click)="viewContactsForCompany(row)"
              [disabled]="
                activeContactAction() === 'all' ||
                activeContactAction() === row.rowKey
              "
            >
              View Company Contacts
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <ng-template #emptyState>
    <p class="company-empty">
      No companies are available for this location yet. Generate target companies from the previous page to see data here.
    </p>
  </ng-template>

  <ng-template #noWebsite>N/A</ng-template>
  <ng-template #contactPending>
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Preparing...</span>
    </span>
  </ng-template>
</div>
